<section class="sap-model-number-decoder-header">
    <hvac-content-header [data]="(sapModelNumberDecoderService.getAdminBreadCrumbData() | async ) || breadCrumbData"></hvac-content-header>
</section>

<section class="hvac-content-container sap-model-number-decoder-container">
    <div class="sap-model-number-decoder-container-header sap-model-number-decoder-heading-default sap-model-number-decoder-heading">
        <h1 class="hvac-h4">{{ 'SAP_PART_NUMBER_DECODER.SUB_HEADING' | translate }}</h1>
    </div>
    <div class="sap-model-number-decoder-description">
        <p class="sap-model-number-decoder-Notes">{{ 'SAP_PART_NUMBER_DECODER.SAP_ONLY_NOTE' | translate }}</p>
        <p class="sap-model-number-decoder-Notes" [innerHTML]="'SAP_PART_NUMBER_DECODER.REFER_TO' | translate"></p>
        <p class="sap-model-number-decoder-Notes">{{ 'SAP_PART_NUMBER_DECODER.NOTE' | translate }}</p>
    </div>

    <form class="hvac-sap-part-number-container">
        <div class="hvac-row">
            <div class="hvac-col-xs-12 hvac-col-lg-4">
                <div class="hvac-row">
                    <div class="hvac-col-xs-12 hvac-col-md-4 hvac-col-lg-4 hvac-label hvac-required">
                        {{ "SAP_PART_NUMBER_DECODER.PART_NUMBER_LABEL" | translate }}
                    </div>
                    <utc-input shadow="light"
                        inputId="sap-part-number"
                        class="hvac-col-xs-12 hvac-col-lg-12"
                        type="text"
                        [inputControl]="partNumberControl"
                        [error]="partNumberControl.dirty && !partNumberControl.valid"
                        [placeholder]="'SAP_PART_NUMBER_DECODER.PART_NUMBER_PLACEHOLDER' | translate"
                        [max]="PART_NUMBER_MAX_LENGTH">
                    </utc-input>
                </div>
            </div>
        </div>

        <div class="hvac-sap-part-number-decoder-actions">
            <button type="button" [hvacButton]="'primary'" (click)="showAhuDetail()">
                {{ 'SAP_PART_NUMBER_DECODER.SHOW_AHU_DETAIL' | translate }}
            </button>
            <button type="button" [hvacButton]="'primary'" (click)="showAhuPartsDetail()">
                {{ 'SAP_PART_NUMBER_DECODER.SHOW_AHU_PARTS_DETAIL' | translate }}
            </button>
        </div>
    </form>
    <div *ngIf="show39lHelpLink">
        <p class="hvac-sap-part-number-decoder-error">{{ 'SAP_PART_NUMBER_DECODER.ERRORS.L39_NOT_ONLINE' | translate}}</p>
        <a class="hvac-text-link" [href]="decode39lPdfUrl" target="_blank" rel="noopener noreferrer">
            {{ 'SAP_PART_NUMBER_DECODER.ERRORS.L39_LINK_TEXT' | translate }}
        </a>
    </div>
</section>
